import {
  derivePairedChangeRequestPresentation,
  type CanonicalPresentationModelV1,
  type ClientChangeRequestTimelineEntryV1,
} from "@enrein/shared-contracts";

export function clientChangePresentation(
  entry: ClientChangeRequestTimelineEntryV1,
  scopeId: string,
  currentPreviewVersion: string | null | undefined,
): CanonicalPresentationModelV1 | null {
  const paired = derivePairedChangeRequestPresentation({
    projectId: scopeId,
    changeRequestId: entry.changeRequestId,
    status: entry.status,
    messagePreview: entry.message,
    createdAt: entry.createdAt,
    startedAt: entry.startedAt,
    resolvedAt: entry.resolvedAt,
    resolvedPreviewVersionId: entry.resolvedPreviewVersionId,
    resolutionMatchesCurrentPassingArtifact:
      entry.status === "RESOLVED" &&
      Boolean(entry.resolvedPreviewVersionId) &&
      entry.resolvedPreviewVersionId === currentPreviewVersion,
    latestPreviewVersionId: currentPreviewVersion,
  });
  return paired?.client ?? null;
}
